import React from 'react';
import { useSettings } from 'services/settings/SettingsContext';
import DetailModal from 'components/modals/DetailModal';
import { HeaderButtonsConfig } from 'types/ButtonTypes';
import { buildInvoiceFieldSections } from './invoiceFieldSections';

// Rename the name of the function:
const InvoiceModal: React.FC<{ viewKey?: string, itemId?: number }> = ({ viewKey, itemId }) => {
    const { environmentSettings } = useSettings();

    // Specify the parameters of this detail modal:
    const apiObject = 'invoice';
    const object = 'invoice';
    const showStatusBar = false;

    // Define the header buttons of the modal:
    const headerButtons: HeaderButtonsConfig = {
        leftButtons: [
            {   
                type: 'secondary',
                label: 'button.download_pdf_button_label',
                action: 'download_pdf',
                objectType: 'invoice',
                allowedRight: ['can_download'],
                query: {
                    endpoint: 'get_pdf_layout_list/invoice',
                    object: 'pdf_layout',
                    defaultParams: { 'deleted': false },
                }
            },
            {   
                type: 'dropdown',
                label: 'button.more_button_label',
                buttons: [
                    {
                        label: 'button.create_credit_invoice_button_label',
                        action: 'create_credit_invoice',
                        restrictedRight: ['only_view'],
                    },
                    {
                        label: 'button.duplicate_invoice_button_label',
                        action: 'duplicate_document',
                        objectType: 'invoice',
                        restrictedRight: ['only_view'],
                    },
                    {
                        label: 'button.make_invoice_periodic_button_label',
                        action: 'make_periodic',
                        allowedFeature: ['periodic_invoices'],
                        restrictedRight: ['only_view'],
                        condition: [{ field: 'is_periodic', values: [false] }],
                    },
                    {
                        label: 'button.delete_invoice_button_label',
                        action: 'delete',
                        restrictedRight: ['only_view'],
                        allowedRight: ['can_delete'],
                    }
                ]
            },
        ],
        rightButtons: [
            {   
                type: 'primary',
                label: 'button.send_invoice_button_label',
                action: 'send_invoice',
                restrictedRight: ['only_view'],
                customClass: 'sent_invoice',
                condition: [{ field: 'status', values: ['draft'] }]
            },
        // {   
        //     type: 'dropdown',
        //     label: 'button.send_invoice_button_label',
        //     buttons: [
        //         {
        //             label: 'button.send_invoice_reminder_button_label',
        //             action: 'send_invoice_reminder',
        //             restrictedRight: ['only_view'],
        //             condition: [{ field: 'status', values: ['overdue', 'reminded'] }]
        //         },
        //         {
        //             label: 'button.send_invoice_again_button_label',
        //             action: 'send_invoice',
        //             restrictedRight: ['only_view'],
        //             condition: [{ field: 'status', notValues: ['draft'] }]
        //         }
        //     ]
        // },
            {
                type: 'secondary',
                label: 'button.register_payment_button_label',
                action: 'register_payment',
                restrictedRight: ['only_view'],
                condition: [{ field: 'status', notValues: ['draft', 'paid'] }]
            },
        ]
    }

    // Define the summary of the modal
    const summary = true;

    // Build the field sections of the invoice
    const sections = buildInvoiceFieldSections({ itemId, environmentSettings, includeDates: true });

    return (
        <DetailModal 
            viewKey={viewKey}
            objectType={object}
            apiObject={apiObject}
            itemId={itemId}
            headerButtons={headerButtons}
            statusBar={showStatusBar}
            sections={sections}
            summary={summary}
        />
    );
};

export default InvoiceModal;